import {
    IMySavedItemsList,
    IPaymentMethodsList,
    IAddressesList,
    IPhysicalStore,
    IUserSettings,
    PersonalDetails,
    PersonalDetailsGeographicInformations,
    PersonalInformation
} from '@interfaces/myProfileInterfaces';

import * as actionTypes from './actionTypes';

// PERSONAL DETAILS

export const getPersonalDetailsPending = () => {
    return {
        type: actionTypes.GET_MY_PROFILE_PERSONAL_DETAILS_PENDING,
    };
};

export const getPersonalDetailsSuccess = (personalDetails: PersonalInformation) => {
    return {
        personalDetails: personalDetails,
        type: actionTypes.GET_MY_PROFILE_PERSONAL_DETAILS_SUCCESS,
    };
};

export const getPersonalDetailsError = () => {
    return {
        type: actionTypes.GET_MY_PROFILE_PERSONAL_DETAILS_ERROR,
    };
};

export const getGeographicInformationsPending = () => {
    return {
        type: actionTypes.GET_GEOGRAPHIC_INFORMATIONS_PENDING,
    };
};

export const getGeographicInformationsSuccess = (
    geographicInformations: PersonalDetailsGeographicInformations
) => {
    return {
        type: actionTypes.GET_GEOGRAPHIC_INFORMATIONS_SUCCESS,
        geographicInformations: geographicInformations,
    };
};

export const getGeographicInformationsError = () => {
    return {
        type: actionTypes.GET_GEOGRAPHIC_INFORMATIONS_ERROR,
    };
};

export const updatePersonalDetailsPending = () => {
    return {
        type: actionTypes.UPDATE_MY_PROFILE_PERSONAL_DETAILS_PENDING,
    };
};

export const updatePersonalDetailsSuccess = () => {
    return {
        type: actionTypes.UPDATE_MY_PROFILE_PERSONAL_DETAILS_SUCCESS,
    };
};

export const updatePersonalDetailsError = () => {
    return {
        type: actionTypes.UPDATE_MY_PROFILE_PERSONAL_DETAILS_ERROR,
    };
};

//SETTINGS

export const updateSettingsPasswordPending = () => {
    return {
        type: actionTypes.UPDATE_SETTINGS_PASSWORD_PENDING,
    };
};

export const updateSettingsPasswordSuccess = () => {
    return {
        type: actionTypes.UPDATE_SETTINGS_PASSWORD_SUCCESS,
    };
};

export const updateSettingsPasswordError = () => {
    return {
        type: actionTypes.UPDATE_SETTINGS_PASSWORD_ERROR,
    };
};

export const updateSettingsPasswordCustomError = (errorMessage: string) => {
    return {
        type: actionTypes.UPDATE_SETTINGS_PASSWORD_CUSTOM_ERROR,
        errorMessage: errorMessage,
    };
};

export const getSettingsUserSettingsPending = () => {
    return {
        type: actionTypes.GET_SETTINGS_USER_SETTINGS_PENDING,
    };
};

export const getSettingsUserSettingsSuccess = (userSettings: IUserSettings) => {
    return {
        type: actionTypes.GET_SETTINGS_USER_SETTINGS_SUCCESS,
        userSettings: userSettings,
    };
};

export const getSettingsUserSettingsError = () => {
    return {
        type: actionTypes.GET_SETTINGS_USER_SETTINGS_ERROR,
    };
};

export const updatePersonalizationSettingsPending = () => {
    return {
        type: actionTypes.UPDATE_PERSONALIZATION_SETTINGS_PENDING,
    };
};
export const updatePersonalizationSettingsSuccess = () => {
    return {
        type: actionTypes.UPDATE_PERSONALIZATION_SETTINGS_SUCCESS,
    };
};
export const updatePersonalizationSettingsError = () => {
    return {
        type: actionTypes.UPDATE_PERSONALIZATION_SETTINGS_ERROR,
    };
};

export const createSubscriptionPending = () => {
    return {
        type: actionTypes.CREATE_SUBSCRIPTION_PENDING,
    };
};

export const createSubscriptionSuccess = () => {
    return {
        type: actionTypes.CREATE_SUBSCRIPTION_SUCCESS,
    };
};

export const createSubscriptionError = () => {
    return {
        type: actionTypes.CREATE_SUBSCRIPTION_ERROR,
    };
};

export const deleteSubscriptionPending = () => {
    return {
        type: actionTypes.DELETE_SUBSCRIPTION_PENDING,
    };
};

export const deleteSubscriptionSuccess = () => {
    return {
        type: actionTypes.DELETE_SUBSCRIPTION_PENDING,
    };
};

export const deleteSubscriptionError = () => {
    return {
        type: actionTypes.DELETE_SUBSCRIPTION_ERROR,
    };
};

// MY STORES

export const getFavouritesStoresPending = () => {
    return {
        type: actionTypes.GET_FAVOURITES_STORES_PENDING,
    };
};

export const getFavouritesStoresSuccess = (favouritesStores: IPhysicalStore[]) => {
    return {
        type: actionTypes.GET_FAVOURITES_STORES_SUCCESS,
        favouritesStores: favouritesStores,
    };
};

export const getFavouritesStoresError = () => {
    return {
        type: actionTypes.GET_FAVOURITES_STORES_ERROR,
    };
};

export const removeFavouriteStorePending = () => {
    return {
        type: actionTypes.REMOVE_FAVOURITE_STORE_PENDING,
    };
};

export const removeFavouriteStoreSuccess = () => {
    return {
        type: actionTypes.REMOVE_FAVOURITE_STORE_SUCCESS,
    };
};

export const removeFavouriteStoreError = () => {
    return {
        type: actionTypes.REMOVE_FAVOURITE_STORE_ERROR,
    };
};

export const setDefaultStorePending = () => {
    return {
        type: actionTypes.SET_DEFAULT_STORE_PENDING,
    };
};

export const setDefaultStoreSuccess = () => {
    return {
        type: actionTypes.SET_DEFAULT_STORE_SUCCESS,
    };
};

export const setDefaultStoreError = () => {
    return {
        type: actionTypes.SET_DEFAULT_STORE_ERROR,
    };
};

// PAYMENT METHODS

export const addPaymentMethodPending = () => {
    return {
        type: actionTypes.ADD_PAYMENT_METHOD_PENDING,
    };
};

export const addPaymentMethodSuccess = () => {
    return {
        type: actionTypes.ADD_PAYMENT_METHOD_SUCCESS,
    };
};

export const addPaymentMethodError = () => {
    return {
        type: actionTypes.ADD_PAYMENT_METHOD_ERROR,
    };
};

export const editPaymentMethodPending = () => {
    return {
        type: actionTypes.EDIT_PAYMENT_METHOD_PENDING,
    };
};

export const editPaymentMethodSuccess = () => {
    return {
        type: actionTypes.EDIT_PAYMENT_METHOD_SUCCESS,
    };
};

export const editPaymentMethodError = () => {
    return {
        type: actionTypes.EDIT_PAYMENT_METHOD_ERROR,
    };
};

export const getPaymentMethodsPending = () => {
    return {
        type: actionTypes.GET_PAYMENT_METHODS_PENDING,
    };
};

export const getPaymentMethodsSuccess = (paymentMethodsList: IPaymentMethodsList) => {
    return {
        type: actionTypes.GET_PAYMENT_METHODS_SUCCESS,
        paymentMethodsList: paymentMethodsList,
    };
};

export const getPaymentMethodsError = () => {
    return {
        type: actionTypes.GET_PAYMENT_METHODS_ERROR,
    };
};

export const setDefaultPaymentMethodPending = () => {
    return {
        type: actionTypes.SET_DEFAULT_PAYMENT_METHOD_PENDING,
    };
};

export const setDefaultPaymentMethodSuccess = () => {
    return {
        type: actionTypes.SET_DEFAULT_PAYMENT_METHOD_SUCCESS,
    };
};
export const setDefaultPaymentMethodError = () => {
    return {
        type: actionTypes.SET_DEFAULT_PAYMENT_METHOD_ERROR,
    };
};

export const removePaymentMethodPending = () => {
    return {
        type: actionTypes.REMOVE_PAYMENT_METHOD_PENDING,
    };
};

export const removePaymentMethodSuccess = () => {
    return {
        type: actionTypes.REMOVE_PAYMENT_METHOD_SUCCESS,
    };
};

export const removePaymentMethodError = () => {
    return {
        type: actionTypes.REMOVE_PAYMENT_METHOD_ERROR,
    };
};

// ADDRESSES

export const getAddressesPending = () => {
    return {
        type: actionTypes.GET_ADDRESSES_PENDING,
    };
};

export const getAddressesSuccess = (addresses: IAddressesList) => {
    return {
        type: actionTypes.GET_ADDRESSES_SUCCESS,
        addressesList: addresses,
    };
};

export const getAddressesError = () => {
    return {
        type: actionTypes.GET_ADDRESSES_ERROR,
    };
};

export const addAddressPending = () => {
    return {
        type: actionTypes.ADD_ADDRESS_PENDING,
    };
};

export const addAddressSuccess = () => {
    return {
        type: actionTypes.ADD_ADDRESS_SUCCESS,
    };
};

export const addAddressError = () => {
    return {
        type: actionTypes.ADD_ADDRESS_ERROR,
    };
};

export const editAddressPending = () => {
    return {
        type: actionTypes.EDIT_ADDRESS_PENDING,
    };
};

export const editAddressSuccess = () => {
    return {
        type: actionTypes.EDIT_ADDRESS_SUCCESS,
    };
};

export const editAddressError = () => {
    return {
        type: actionTypes.EDIT_ADDRESS_ERROR,
    };
};

export const setDefaultAddressPending = () => {
    return {
        type: actionTypes.SET_DEFAULT_ADDRESS_PENDING,
    };
};

export const setDefaultAddressSuccess = () => {
    return {
        type: actionTypes.SET_DEFAULT_ADDRESS_SUCCESS,
    };
};

export const setDefaultAddressError = () => {
    return {
        type: actionTypes.SET_DEFAULT_ADDRESS_ERROR,
    };
};

export const deleteAddressPending = () => {
    return {
        type: actionTypes.DELETE_ADDRESS_PENDING,
    };
};

export const deleteAddressSuccess = () => {
    return {
        type: actionTypes.DELETE_ADDRESS_SUCCESS,
    };
};

export const deleteAddressError = () => {
    return {
        type: actionTypes.DELETE_ADDRESS_ERROR,
    };
};

// MY SAVED ITEMS

export const getMySavedItemsPending = () => {
    return {
        type: actionTypes.GET_MY_SAVED_ITEMS_PENDING,
    };
};

export const getMySavedItemsSuccess = (mySavedItems: IMySavedItemsList) => {
    return {
        type: actionTypes.GET_MY_SAVED_ITEMS_SUCCESS,
        mySavedItems: mySavedItems,
    };
};

export const getMySavedItemsError = () => {
    return {
        type: actionTypes.GET_MY_SAVED_ITEMS_ERROR,
    };
};

export const getUserSubscriptionEmail = (userSubscriptionEmail: boolean) => {
    return {
        type: actionTypes.GET_USER_SUBSCRIPTION_EMAIL,
        userSubscriptionEmail: userSubscriptionEmail,
    }
}

export const getUserSubscriptionPhone = (userSubscriptionPhone: boolean) => {
    return {
        type: actionTypes.GET_USER_SUBSCRIPTION_PHONE,
        userSubscriptionPhone: userSubscriptionPhone,
    }
}

export const getUserSubscriptionEmailChanged = (userSubscriptionEmailChanged: boolean) => {
    return {
        type: actionTypes.GET_USER_SUBSCRIPTION_EMAIL_CHANGED,
        userSubscriptionEmailChanged: userSubscriptionEmailChanged,
    }
}

export const getUserSubscriptionPhoneChanged = (userSubscriptionPhoneChanged: boolean) => {
    return {
        type: actionTypes.GET_USER_SUBSCRIPTION_PHONE_CHANGED,
        userSubscriptionPhoneChanged: userSubscriptionPhoneChanged,
    }
}

export const getUserSubscriptionCorrect = (userSubscriptionCorrect: boolean) => {
    return {
        type: actionTypes.GET_USER_SUBSCRIPTION_CORRECT,
        userSubscriptionCorrect: userSubscriptionCorrect,
    }
}

